export default __webpack_public_path__ + "static/media/rain.78692c09.svg";